import { useSelector } from 'react-redux';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { TabPanel, TabView } from 'primereact/tabview';
import React, { useEffect, useState } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { Dialog } from 'primereact/dialog';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import { DateTemplate } from '../../../components/dateTemplate/DateTemplate';
import {
    useGetCaApprovalStatusHistoryQuery,
    useGetCaHistoryQuery,
} from '../../../pages/correctiveActions/correctiveActionsSlice';
import ExpiredIcon from '../../../assets/stalledIcon.png';
import './CaHistory.scss';
import { selectCurrentEmpid } from '../../../pages/login/authSlice';
import ReadConversationModalBody from '../../../components/readConversationModalBody/ReadConversationModalBody';
import { exportConversationExcel } from '../../../components/conversation/conversation-service';
import { useGetCoachingConversationViewQuery } from '../../../components/conversation/conversationSlice';
import { datetimeToDate } from '../../../utils/dateFormat';
import { CoachingEntityTypes } from '../../../utils/typeConstants';


interface CaHistoryProps {
    employeNumber: any;
    caId?: number;
    showMisconduct?: boolean;
    // caType?: string;
}

export const CaHistory = (props: CaHistoryProps) => {
    const [history, setHistory] = useState<any>();
    const [approvalStatusHistory, setApprovalStatusHistory] = useState<any>();
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const [conversationRowData, setConversationRowData] = useState<any>({});
    const [selectedRowItem, setSelectedRowItem] = useState<any>({});
    const [displayModal, setDisplayModal] = useState(false);
    const [isResponse, setIsResponse] = useState(false);
    const [commentView, setCommentView] = useState(false);
    const [conversationData, setConversationData] = useState([]);
    // console.log('caType', props.caType);

    const { data: caHistory } = useGetCaHistoryQuery(
        {
            empNo: props.employeNumber?.employeeNumber,
            loggedEmpNum,
        },
        {
            skip: !props.employeNumber?.employeeNumber || !loggedEmpNum,
        }
    );
    const { data: caApprovalStatusHistory } = useGetCaApprovalStatusHistoryQuery(
        {
            caId: props.caId,
        },
        {
            skip: !props.caId,
        }
    );
    const { data: conversationViewData } = useGetCoachingConversationViewQuery(
        {
            employeeNumber: props.employeNumber?.employeeNumber,
            searchOracleId: props.employeNumber?.employeeNumber,
            teamType: 'myconversations',
            userRole: 'teamlead',
            fromDate: datetimeToDate(new Date(1, 1, 1)),
            toDate: datetimeToDate(new Date()),
            viewAllEmps: true,
        },
        {
            skip:
                !props?.employeNumber,
        }
    );
    useEffect(() => {
        setApprovalStatusHistory(
            caApprovalStatusHistory?.data?.length > 0 ? caApprovalStatusHistory.data : []
        );
    }, [caApprovalStatusHistory]);
    useEffect(() => {
        const data = conversationViewData?.data?.filter((element: any) => (element.coaching_entity_type_id === CoachingEntityTypes.CorrectiveActions && element.coaching_entity_id === props.caId));
        setConversationData(data);
    }, [conversationViewData]);
    const expiredStatusIcon = (rowData: any) => {
        return <div>{rowData.expired ? <img className="caHistoryExpiredIcon justify-content-left " src={ExpiredIcon} alt="Expired" /> : ''}
            <Tooltip target=".caHistoryExpiredIcon" position="top">
                <div id="expiredCa" className="tooltip-content">
                    <span style={{ minWidth: '1px' }}>Expired</span>
                </div>
            </Tooltip>
        </div>;
    };
    const onConversionClick = (event: any) => {
        if (event.field === 'conversation_subject') {
            setConversationRowData([event?.rowData]);
            setDisplayModal(true);
            const rowDetails = {
                'coaching_conversation_id': event?.rowData?.coaching_conversation_id,
                'conversation_subject': event?.rowData?.conversation_subject,
                'conversation_date': event?.rowData?.conversation_date,
                'core_value_name': event?.rowData?.core_value_name,
                'coaching_conversation_category_name': event?.rowData?.category_name,
                'conversation_description': event?.rowData?.conversation_description,
                'visible_to_recipient': event?.rowData?.visible_to_recipient,
                'author_name': event?.rowData?.author,
                'author_employee_number': event?.rowData?.author.split('(')[1]?.slice(0, 7),
                'response_date': event?.rowData?.response_date,
                'response_description': event?.rowData?.response_description,
                'response_by_name': event?.rowData?.responder,
                'response_employee_number': event?.rowData?.responder?.split('(')[1]?.slice(0, 7),
                'recipient': event?.rowData?.recipient,
                'core_value_id': event?.rowData?.core_value_id,
                'conversation_documents': event?.rowData?.conversation_documents,
                'acknowledge_employee_number': event?.rowData?.acknowledge_employee_number,
                'acknowledge_date': event?.rowData?.acknowledge_date,
                'acknowledged': event?.rowData?.acknowledged,
                'employee_number': event?.rowData?.employee_number
            };
            setSelectedRowItem(rowDetails);
            if (rowDetails?.response_description !== null) {
                setIsResponse(true);
            } else {
                setIsResponse(false);
            }
        }
    };
    const dateBodyTemplate = (rowData: any) => {
        return DateTemplate(rowData.conversation_date);
    };
    useEffect(() => {
        setHistory(caHistory?.data?.length > 0 ? caHistory.data : []);
    }, [caHistory]);
    const modalHeader = () => {
        return (
            <h4 className="pe-3">
                <span style={{ fontWeight: 700 }} className="pt-2">
                    {'Discussion Log'}
                </span>
            </h4>
        );
    };

    const modalFooter = () => {
        return (
            <React.Fragment>
                <Divider />
                <div className="d-flex justify-content-end gap-2">
                    <Button
                        className="btn-secondary"
                        onClick={() => {
                            setDisplayModal(false);
                            setCommentView(false);
                            setIsResponse(false);
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        type="button"
                        icon="pi pi-upload me-2"
                        className="btn-export"
                        onClick={() => {
                            exportConversationExcel('conversationlog', conversationRowData);
                        }}
                        data-pr-tooltip="XLS"
                    >
                        Export
                    </Button>
                </div>
            </React.Fragment>
        );
    };

    return (
        <TabView>
            {
                <TabPanel header="Corrective Action History">
                    <DataTable
                        value={history}
                        className="ca-dashboard"
                        rows={5}
                        paginator={history?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                        <Column
                            headerStyle={{ width: '1px' }}
                            bodyStyle={{ width: '1px' }}
                            body={expiredStatusIcon}
                        />
                        <Column
                            header="Author"
                            field="author_employee_name"
                            sortable
                            sortField="author_employee_name"
                        />
                        <Column
                            header="Category"
                            field="ca_category_name"
                            sortable
                            sortField="ca_category_name"
                        />
                        {props?.showMisconduct ? (
                            <Column
                                header="Misconduct"
                                field="ca_misconduct_name"
                                sortable
                                sortField="ca_misconduct_name"
                            />
                        ) : (
                            <Column
                                header="Sub Category"
                                field="ca_subcategory_name"
                                sortable
                                sortField="ca_subcategory_name"
                            />
                        )}
                        <Column
                            header="Severity Level"
                            field="severity_level_name"
                            sortable
                            sortField="severity_level_name"
                        />
                        <Column header="Status" field="ca_status_name" sortable sortField="ca_status_name" />
                        <Column
                            header="Issued"
                            field='in_training'
                            sortable
                            sortField='in_training'
                            body={(item) => (item.in_training ? 'Training' : 'Production')}
                        />
                        <Column
                            header="Date"
                            field="create_date" style={{ minWidth: '8rem' }}
                            body={(date) => (date.create_date ? DateTemplate(date?.create_date) : '--')}
                        />
                        <Column
                            header="Release"
                            field="release_date"
                            sortable
                            sortField="release_date" style={{ minWidth: '8rem' }}
                            body={(date) => (date.release_date ? DateTemplate(date?.release_date) : '--')}
                        />
                        <Column
                            header="Expiry"
                            field="expired_date"
                            sortable
                            sortField="expired_date" style={{ minWidth: '8rem' }}
                            body={(date) => (date.expired_date ? DateTemplate(date?.expired_date) : '--')}
                        />
                    </DataTable>
                </TabPanel>
            }

            {
                <TabPanel header="Approvers Status">
                    <DataTable
                        value={approvalStatusHistory}
                        className="ca-dashboard"
                        rows={5}
                        paginator={history?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                        <Column
                            header="Approval"
                            field="approver_employee_name"
                            sortable
                            sortField="approver_employee_name"
                        />
                        <Column
                            header="Role"
                            field="ca_approver_role_name"
                            sortable
                            sortField="ca_approver_role_name"
                        />

                        <Column
                            header="Status"
                            field="ca_approval_action_name"
                            sortable
                            sortField="ca_approval_action_name"
                        />
                        <Column
                            header="Date"
                            field="approval_action_date"
                            body={(date) =>
                                date.approval_action_date ? DateTemplate(date?.approval_action_date) : '--'
                            }
                        />
                        <Column
                            header="Comments"
                            field="approval_action_comment"
                            sortable
                            sortField="approval_action_comment"
                        />
                    </DataTable>
                </TabPanel>
            }
            {conversationData?.length > 0 &&
                <TabPanel header="Discussions">
                    <DataTable
                        value={conversationData}
                        dataKey="conversation_id"
                        className="conversationTable"
                        scrollable
                        scrollHeight="600px"
                        rows={5}
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        paginator={conversationData?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        onCellClick={onConversionClick}
                        cellSelection
                        selectionMode="single"
                    >
                        <Column
                            header="Date"
                            field="conversation_date"
                            headerStyle={{ minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            sortable
                            sortField="conversation_date"
                            body={dateBodyTemplate}
                            filterField="conversation_date"
                            dataType="date"
                        />
                        <Column
                            header="Discussion"
                            field="conversation_subject"
                            headerStyle={{ minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem', color: '#007bff', textDecoration: 'underline' }}
                            sortable
                            sortField="conversation_subject"
                        />
                        <Column
                            header="Recipient"
                            field="recipient"
                            headerStyle={{ minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            sortable
                            sortField="recipient"
                        />
                        <Column
                            header="Author"
                            field="author"
                            headerStyle={{ minWidth: '15rem' }}
                            bodyStyle={{ minWidth: '15rem' }}
                            sortable
                            sortField="author"
                        />
                        <Column
                            header="Category"
                            field="category_name"
                            sortable
                            sortField="category_name"
                            style={{ minWidth: '13rem' }}
                            filterField="category_name"
                            showFilterMatchModes={false}
                        />
                    </DataTable>
                    <Dialog
                        header={modalHeader}
                        footer={modalFooter}
                        visible={displayModal}
                        style={{ width: '60vw' }}
                        onHide={() => {
                            setDisplayModal(false);
                            setCommentView(false);
                            setIsResponse(false);
                        }}
                    >
                        <ReadConversationModalBody
                            listItem={selectedRowItem}
                            setSelectedRowItem={setSelectedRowItem}
                            setCommentView={setCommentView}
                            setIsResponse={setIsResponse}
                            commentView={commentView}
                            isResponse={isResponse}
                            receiverName={selectedRowItem?.recipient}
                            receiverId={selectedRowItem?.recipient?.split('(')[1]?.slice(0, 7)}
                            coreValueId={selectedRowItem?.core_value_id}
                            convId={selectedRowItem?.coaching_conversation_id}
                            setDisplayModal={setDisplayModal}
                            acknowledged={selectedRowItem?.acknowledged}
                        />
                    </Dialog>
                </TabPanel>
            }
        </TabView>
    );
};
